module.exports = __webpack_public_path__ + "static/images/general/menu_down_white.svg";